import { render } from "./ContractLocations.vue?vue&type=template&id=35f70933"
import script from "./ContractLocations.vue?vue&type=script&lang=js"
export * from "./ContractLocations.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__